let ticking = false

export default {
  inserted(el, binding) {
    el.__scrollHandler__ = function handler() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          binding.value()

          ticking = false
        })

        ticking = true
      }
    }

    window.addEventListener('scroll', el.__scrollHandler__, { passive: true })
  },

  unbind(el) {
    if (!el.__scrollHandler__) {
      return
    }

    window.removeEventListener('scroll', el.__scrollHandler__)
    delete el.__scrollHandler__
  }
}
